import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import argocdPlugin from '@platform/plugin-argocd';
import { showArgocdDeploymentsTab } from './argocdTab';

// Vue d'ensemble des partenaires : leurs domaines (URL, site, certificat)
const domainsCard = EntityCardBlueprint.make({
  name: 'partner-domains',
  params: {
    filter: { kind: 'Resource', 'spec.type': 'partner' },
    loader: async () => import('./DomainsCard').then(m => <m.DomainsCard />),
  },
});

// État ArgoCD de tous les environnements, sous les domaines
const deploymentsCard = EntityCardBlueprint.make({
  name: 'partner-deployments',
  params: {
    filter: { kind: 'Resource', 'spec.type': 'partner' },
    loader: async () => import('./DeploymentsCard').then(m => <m.DeploymentsCard />),
  },
});

export const partnersModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [domainsCard, deploymentsCard],
});

// Onglet « Déploiements » du plugin ArgoCD : retiré des partenaires (carte ci-dessus)
export const partnersArgocdModule = createFrontendModule({
  pluginId: 'argocd',
  extensions: [
    argocdPlugin
      .getExtension('entity-content:argocd/deployments')
      .override({ params: { filter: showArgocdDeploymentsTab } }),
  ],
});

// « Tous les partenaires » (/partenaires), accessible depuis Applications → Partenaires.
// Sans icône : pas d'entrée automatique en bas du menu (elle est placée à la main, voir nav).
export const partnersPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'partners',
      params: {
        path: '/partenaires',
        // La page porte son propre en-tête (Header) : pas de barre de titre automatique.
        noHeader: true,
        loader: () => import('./PartnersPage').then(m => <m.PartnersPage />),
      },
    }),
  ],
});
